const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const roundOfAndFormate = (value, currencyFormate = false) => {
  if (!value) return '';
  const roundValue = parseFloat(parseFloat(value)?.toFixed(2));
  if (currencyFormate) {
    return currencyFormatter.format(roundValue);
  }
  return roundValue.toLocaleString('en-SG');
};
